import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Responses } from 'src/app/shared/interfaces/responses';
import { Rol } from 'src/app/shared/interfaces/rol';

@Injectable({
  providedIn: 'root'
})
export class RolesService {
  private urlBase = environment.urlBase;
  constructor(
    private http: HttpClient,
  ) { }

  // Obtiene todos los roles activos
  getRoles(): Observable<Responses>{
     return this.http.post<Responses>(`${this.urlBase}roles/getRoles`, null);
  }
   //Función para registrar el Rol
  createRol(rol: Rol): Observable<Responses>{
    return this.http.post<Responses>(`${this.urlBase}roles/createRol`, rol);
  }
  //Función para actualizar el Rol
  updateRol(rol: Rol): Observable<Responses>{
    return this.http.post<Responses>(`${this.urlBase}roles/updateRol`, rol);
  }
    //Función para eliminar el Rol
  deleteRol(rol: Rol): Observable<Responses>{
    return this.http.post<Responses>(`${this.urlBase}roles/deleteRol`, rol);
  }

  getRolEnUso(rol: Rol): Observable<Responses>{
    return this.http.post<Responses>(`${this.urlBase}roles/getRolEnUso`, rol);
  }
  
}
